<!-- 
  This component allows you to conditionally wrap a template in component or tag.

  If 'when' is false, then the template is not wrapped and rendered as is.
  If when is true, then the template is wrapped in the component or tag specified by 'is'.

  Only accepts one child element.
-->

<script>
export default {
  name: 'BaseConditionalWrap',
  functional: true,
  props: {
    when: {
      type: Boolean,
      default: false
    },
    is: { 
      type: [String, Object],
      default: 'div'
    }
  },
  render(h, { props, data, slots }) {
    const children = (slots().default || []).filter(Boolean);
    if (!props.when) return children[0] || null; // renders no extra DOM when false
    return h(props.is, data, children); // forwards attrs/listeners via data
  }
}
</script>